// UserContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';

// Create a Context
const GeneralContext = createContext();

// Create a Provider component
export const VerbiageContextProvider = ({ children }) => {
  const { user } = useAuthUser();
  const [verbiageSettings, setVerbiageSettings] = useState({});
  const fetchcompanyData = async () => {
    try {
      const response = await jwtAxios.get(`/app-settings/`);
      const { data } = response;
      const verbiageData =
        Object.keys(data?.display)?.length === 0 ? {} : data?.display;
      setVerbiageSettings(verbiageData);
      localStorage.setItem('verbiageSettings', JSON.stringify(data?.display));
    } catch (error) {
      console.error('Error fetching appearance settings:', error);
    }
  };
  useEffect(() => {
    if (
      user &&
      verbiageSettings &&
      Object.keys(verbiageSettings)?.length === 0
    ) {
      fetchcompanyData();
    }
  }, [user, verbiageSettings]);

  if (verbiageSettings) {
    localStorage.setItem('verbiageSettings', JSON.stringify(verbiageSettings));
  }
  return (
    <GeneralContext.Provider value={{ verbiageSettings, setVerbiageSettings }}>
      {children}
    </GeneralContext.Provider>
  );
};

// Create a custom hook to use the context
export const useApplicationSettings = () => useContext(GeneralContext);
